module.exports = __webpack_public_path__ + "media/svg/circle_location-ba06f678.svg";